import { useSelector } from 'react-redux'
import { useState, useEffect } from "react";
import { Grid, Card, Alert, AlertTitle } from '@mui/material';
import { gridSpacing } from '../../store/constant';
import StickyHeadTable from '../components/StickyHeadTable';
import axios from "../../components/axios";
import { useNavigate } from 'react-router-dom';


const columns = [
  { id: 'token', label: 'Token', align: 'left'},
  { id: 'jenkins_job', label: 'Jenkins Job', align: 'center'},
  { id: 'build_number', label: 'Build Number', align: 'center'},
  { id: 'update_time', label: 'Create Time', align: 'center'},
  { id: 'action', label: 'Detail', align: 'center', skip: true},
];

const TestQueuePage = () => {
    const customization = useSelector((state) => state.customization);
    const navigate = useNavigate();
    const [rows, setRows] = useState([]);
    const [showAlert, setshowAlert] = useState(false);

    useEffect(() => {
        const getTestQueue = async () => {
            try {
                setshowAlert(false);
                const response = await axios.post("/peloton/v1/automation/combinations", null, { withCredentials: true});
                if (response.data.message === "success"){
                    if (response.data.data !== null){
                        setRows(response.data.data);
                    }else{
                        setshowAlert(true);
                    }
                }
            } catch (error) {
                if (error.response.status !== null){
                    if (error.response.status === 401){
                        alert(error.response.data.message);
                        navigate("/");
                    }else{
                        console.log('error.response.status: ', error.response.status)
                        console.log('error.response.message: ', error.response.data.message)
                    }
                }else{
                    console.log(error);
                }
            }
        };
        getTestQueue();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleDetail = (uuid) => {
        navigate('/test-detail/'+uuid);
    };

    const handleDelete = (uuid) => {
        var input_data = JSON.stringify({ token: uuid });
        axios.post("/peloton/v1/automation/combination-skip",input_data,{withCredentials: true})
        .then(response => {
            if (response.data.message === "success") {
                alert(response.data.message);
                window.location.href = '/#/test-queue';
            }else{
                alert(response.data.message);
            }
        }).catch(function(err){
            if (!err.response){
                alert(err);
            }else{
                if (err.response.status === 401){
                    alert(err.response.data.message);
                    navigate("/");
                }else{
                    console.log('error.response.status: ', err.response.status)
                    console.log('error.response.message: ', err.response.data.message)
                    alert(err.response.data.message)
                }
            }
        })
    };

    return (
        <Grid container spacing={gridSpacing} alignItems="center" sx={{ marginTop: "40px"}}>
            <Grid item xs={12} >
                {customization.login && (<StickyHeadTable rows={rows} columns={columns} handleEdit={handleDetail} handleDelete={handleDelete} title="Test Queue"/>)}
            { showAlert && (<Card variant="outlined" sx={{ bgcolor: "white" }}><Alert severity="warning">
                <AlertTitle>Warning</AlertTitle>
                No data in this condition.
              </Alert></Card>)}
            </Grid>
        </Grid>
    );
};

export default TestQueuePage;
